import React from "react";
import classNames from "classnames";
import styled from "styled-components";
import { ThemedIcon } from "../utilities";
import { variantToColour } from "../../helpers/theme";
import { Form, OverlayTrigger, Popover } from "react-bootstrap";


export const StyledLabel = styled.label`
    line-height: normal;
    color: ${props => variantToColour({ theme: props.theme, variant: props.variant ? props.variant : 'primary' })};
`;

const FormLabel = ({ 
    as, 
    children, 
    className,
    disabled = false,
    helpText = null, 
    horizontal, 
    labelClassName = null,
    variant = "primary", 
    ...rest 
}) => {
    if (!children && !helpText) {
        return null;
    }

    return (
        <div className={classNames({
            'col-sm-2 col-form-label': horizontal === true,
            'd-flex': (!horizontal || horizontal === false)
        }, className)}>
            {children && (
                <Form.Label 
                    as={typeof (children) === 'object' ? 'div' : StyledLabel} 
                    variant={variant} 
                    className={classNames("flex-fill text-nowrap", labelClassName, "m-0", { 'form-label-disabled': disabled === true })}
                    {...rest}
                >
                    {children}
                </Form.Label>
            )}
            {helpText && (!horizontal || horizontal === false) && (
                <OverlayTrigger
                    placement="left"
                    overlay={
                        <Popover>
                            <Popover.Body style={{ textAlign: 'left' }}>
                                {helpText}
                            </Popover.Body>
                        </Popover>
                    }
                >
                    <div>
                        <ThemedIcon icon="fa-regular fa-circle-question" variant="primary" />
                    </div>
                </OverlayTrigger>
            )}
        </div>
    );
}

export default FormLabel;